import { useQuery } from 'react-query'
import api from '../../services/api';

const fetchCompanies = () => api.get('/company/search').then((res) => res.data);

export default function useCompanies() {
  return useQuery('companies', fetchCompanies);
}